<!--
 * @Date: 2020-05-12 16:34:12
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-29 09:48:27
 * @FilePath: /xy-pc/src/views/homelayout/superteacher/teacherdetail.vue
--> 
<template>
  <div style="width:100%">
    <div class="tabNav">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/superteacher' }">明星讲师</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row style="min-height:60vh">
      <el-col :span="6" style="text-align:center">
        <el-image class="headImg" :src="userInfo.avatar" alt srcset />
        <span class="teacherName">{{userInfo.real_name}}</span>
      </el-col>
      <el-col :span="18" style="padding-top:30px">
        <el-form label-width="120px" class="teacherForm">
          <el-form-item label="职称：">
            <span>{{userInfo.professional}}</span>
          </el-form-item>
          <el-form-item label="主讲项目：">
            <span>{{userInfo.project.name}}</span>
          </el-form-item>
          <el-form-item label="简介：">
            <div  v-html="userInfo.expertise"></div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "newsdetails",

  props: {},
  data() {
    return {
      userInfo: {
        avatar: "",
        expertise: "",
        introduce: "",
        professional: "",
        project: "",
        real_name: ""
      },
      value: ""
    };
  },
  mounted() {},
  computed: {},
  created() {
    this.getdetail(this.$route.query.id);
  },
  methods: {
    getdetail(id) {
      this.$http({
        url: "api/v1/star-lecturers/" + id,
        method: "get"
      }).then(res => {
        if (res.status == 200) {
          this.userInfo = res.data.star_lecturer.expert;
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="less" >
.teacherForm {
  .el-form-item__label {
    font-weight: 600;
    font-size: 16px;
  }
}

</style>
<style lang="less" scoped>

.tabNav {
  padding: 20px 0;
}
.headImg {
  width: 100px;
  height: 100px;
  display: block;
  border-radius: 50%;
  border: rgba(236, 238, 241, 1) solid 1px;
  margin: 30px auto;
}
.teacherName {
  padding-top: 40px;
  font-size: 24px;
}
.newsdetails {
  padding-bottom: 100px;
  float: right;
  width: 100%;
  border-radius: 10px;
  box-sizing: border-box;
  text-align: center;

  .name {
    display: block;

    text-align: center;
    line-height: 90px;
    font-weight: bold;
    font-size: 24px;
  }
  .title {
    width: 100%;
    margin-bottom: 20px;
    overflow: hidden;

    .head {
      float: left;
      margin-right: 12px;
      width: 90px;
      height: 90px;
      text-align: center;
      border-radius: 50%;
      border: rgba(236, 238, 241, 1) solid 1px;
      img {
        margin-top: 7px;
        width: 76px;
        height: 76px;
        border-radius: 50%;
      }
    }
  }
  .creat-time {
    width: 100%;
    margin-bottom: 20px;
    font-size: 20px;
  }
  .content {
    line-height: 30px;
  }
}
</style>